import { Controller } from '@hotwired/stimulus'

const OFFSET = 12

export default class extends Controller<HTMLElement> {
  static targets = ['content']

  declare contentTarget: HTMLElement

  hover(): void {
    const tooltip = document.querySelector('ui-tooltip') as HTMLElement
    tooltip.innerHTML = this.contentTarget.innerHTML

    const screenWidth = window.innerWidth
    const triggerBox = this.element.getBoundingClientRect()

    // make the tip visible
    tooltip.showPopover()
    tooltip.style.opacity = '100'
    tooltip.style.overflow = 'visible'
    tooltip.style.margin = '0'

    // basic measurements to calculate

    const xCenter = triggerBox.left + triggerBox.width / 2 - tooltip.offsetWidth / 2
    const yOffsetTopRaw = triggerBox.top + OFFSET

    tooltip.style.left = `${xCenter}px`
    tooltip.style.top = `${yOffsetTopRaw}px`

    // calculations to assess if the tooltip overflows the screen

    const tipBox = tooltip.getBoundingClientRect()
    const yOffsetTop = triggerBox.top + triggerBox.height / 2 - tipBox.height / 2

    // OVERFLOW 1 - align the tip left when it overflows to the right (end of page)
    if (tipBox.left + tipBox.width > screenWidth) {
      tooltip.style.left = `auto`
      tooltip.style.bottom = `auto`
      const xOffsetLeft = screenWidth - triggerBox.left + OFFSET / 2
      tooltip.style.right = `${xOffsetLeft}px`
      tooltip.style.top = `${yOffsetTop}px`
      tooltip.setAttribute('position', 'left')
    }

    // OVERFLOW 2 - align the tip right when it overflows to the left (start of page)
    else if (tipBox.left < 0) {
      tooltip.style.bottom = `auto`
      const xOffsetRight = triggerBox.right + OFFSET
      tooltip.style.left = `${xOffsetRight}px`
      tooltip.style.top = `${yOffsetTop}px`
      tooltip.setAttribute('position', 'right')
    }

    // OVERFLOW 3 - align the tip bottom when it overflows to the top (start of page)
    else if (tipBox.top - tipBox.height < 30) {
      tooltip.style.bottom = `auto`
      tooltip.style.top = `${triggerBox.bottom + OFFSET}px`
      tooltip.setAttribute('position', 'bottom')
    }

    // OVERFLOW 4 - happy case, align the tip top
    else {
      tooltip.style.top = `${yOffsetTop - tipBox.height / 2 - OFFSET * 2}px`
      tooltip.setAttribute('position', 'top')
    }
  }

  leave(): void {
    const tooltip = document.querySelector('ui-tooltip') as HTMLElement
    tooltip.hidePopover()
  }
}
